import styles from './DataSourceBanner.module.css';

/**
 * States the provenance of what is on screen.
 *
 * The error copy used to read "showing the design fixture", which was true of
 * the old behaviour and is a promise this page no longer keeps: a failed load
 * now shows empty tables. Saying otherwise would send a reader looking for
 * numbers that are not there.
 */
export function DataSourceBanner({ kind, detail }: { kind: 'fixture' | 'error'; detail?: string }) {
  return (
    <div className={`${styles.banner} ${kind === 'error' ? styles.error : styles.fixture}`} role="status">
      <span className={styles.dot} />
      {kind === 'error'
        ? 'Live data unavailable — no figures are shown rather than stale or invented ones.'
        : 'Showing design fixture data, not live BigQuery.'}
      {detail && <span className={styles.detail}>{detail}</span>}
    </div>
  );
}
